module.exports = __webpack_public_path__ + "img/data_icon_001.103f79ac.png";